import { World } from '$legacyecstatic';
import { Components } from 'editor/components';
import TileSheet from 'editor/components/TileSheet';

const _getScale = (world: World<Components>): number => {
  const tileSheetComp = world.getComponent(TileSheet);

  if (!tileSheetComp) return 1;

  return tileSheetComp.scale;
};

type Transform = [number, number, number, number, number, number];

export const getSheetToScreenTransform = (
  world: World<Components>
): Transform => {
  const scale = _getScale(world);
  return [scale, 0, 0, scale, 0, 0];
};

export const getScreenToSheetTransform = (
  world: World<Components>
): Transform => {
  const scale = _getScale(world);
  const inverseScale = 1 / scale;
  return [inverseScale, 0, 0, inverseScale, 0, 0];
};
